import { useSafeQuery } from './useSafeQuery'
import { getSupabaseFileExtension } from '../utils/note'
import { cacheKeys } from '../utils/queryKeyFactory'
import { useAuthenticatedUser } from '../providers/UserProvider'
import { AuthType } from '../utils/User'
import { cachedNotesContext } from '../contexts/CachedNotes'
import { fetchFileExtension } from '../lib/cloudkit/fetch'

/**
 * Non-hook version of private notes extension fetching
 * Can be used in batch operations and other non-React contexts
 */
export async function getPrivateNotesExtension(
  authType: AuthType
): Promise<string> {
  switch (authType) {
    case AuthType.CLOUDKIT_SUPABASE:
    case AuthType.CLOUDKIT: {
      return await fetchFileExtension()
    }
    case AuthType.SUPABASE: {
      return getSupabaseFileExtension()
    }
    default: {
      // Fallback to 'md' for unknown auth types
      return 'md'
    }
  }
}

// This is only used for private notes
// For team notes, we use getSupabaseFileExtension
export function usePrivateNotesExtension() {
  const user = useAuthenticatedUser()

  return useSafeQuery({
    context: cachedNotesContext,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
    queryKey: cacheKeys.extension(user.authType),
    queryFn: () => getPrivateNotesExtension(user.authType),
  })
}
